import React from 'react';
import {useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {Form, Button, Divider} from '@innowise-group/ui-kit';
import {SelectLocationForm, SelectLocationFormValues} from '../select-location-form';
import {OfficeInformationForm, OfficeInformationFormValues} from '../office-information-form';
import {FloorsForm, FloorsFormValues} from '../floors-form';
import {ManagerTypes, Office} from '@innowise-group/core';

export type OfficeFormSection = 'location' | 'floor';

export type OfficeFormValues = SelectLocationFormValues &
  OfficeInformationFormValues &
  FloorsFormValues & {managers: {office_manager: string; manager_type: ManagerTypes}[]};

type OfficeFormLayoutProps = {
  sectionsToShow?: OfficeFormSection[];
  initialValues?: Partial<OfficeFormValues>;
  onCancel: () => void;
  isSubmit?: boolean;
  offices?: Office[];
};

const OfficeFormLayout: React.FC<OfficeFormLayoutProps> = ({
  sectionsToShow = ['location', 'floor'],
  initialValues = {},
  onCancel,
  isSubmit,
  offices,
}) => {
  const {
    formState: {isValid, isSubmitting, isDirty},
  } = useFormContext();

  const {t} = useTranslation();
  const {location, address, address_eng, index, floors, jira_office_id} = initialValues;

  return (
    <>
      {sectionsToShow.length ? (
        sectionsToShow.includes('location') ? (
          <>
            <Form.Layout layoutType="vertical">
              <SelectLocationForm defaultValue={{location: location ?? '', index: index ?? ''}} />
            </Form.Layout>

            <Divider />

            <Form.Layout layoutType="vertical">
              <OfficeInformationForm
                initialValues={{address, address_eng, jira_office_id}}
                floors={floors}
                showFloorsForm={sectionsToShow.includes('floor')}
                offices={offices}
              />
            </Form.Layout>

            <Divider />
          </>
        ) : (
          <>
            <Form.Layout layoutType="vertical" inset="bottom">
              <FloorsForm initialValues={{floors}} />
            </Form.Layout>

            <Divider />
          </>
        )
      ) : null}

      <Form.Actions>
        <Button type="submit" disabled={isSubmit || !isValid || isSubmitting || !isDirty} withLoader={isSubmit}>
          {t('buttons.save')}
        </Button>
        <Button variant="outlined" onClick={onCancel}>
          {t('buttons.cancel')}
        </Button>
      </Form.Actions>
    </>
  );
};

export default OfficeFormLayout;
